import { Options, ChangeContext, PointerType } from '@angular-slider/ngx-slider';
import { Component, DoCheck, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Artikel } from 'src/app/modules/webshop/store/models/artikel';

@Component({
    selector: 'kkis-app-webshop-filter-container1',
    templateUrl: './filter-container1.component.html',
    styleUrls: ['./filter-container1.component.scss']
})
export class FilterContainer1Component implements OnInit, OnChanges {

    @Input()
    category: string;

    @Input()
    minPreis: number;

    @Input()
    maxPreis: number;

    @Input()
    groessen: Artikel.IArtikelListSettingGroessenDto[];

    @Input()
    farben: Artikel.IArtikelListSettingFarbenDto[];

    @Input()
    filterGroessen: string;

    @Input()
    filterFarben: string;

    @Input()
    filterMerkmale: string;

    @Input()
    merkmalGruppen: Artikel.IMerkmalGruppeDto[];

    @Input()
    nurAufLager: boolean = false;

    @Input()
    removeFilter: Artikel.IMerkmalDto;

    // Filter:Preis
    options: Options = {};

    // Filter:Größe + Farbe + Merkmale
    _filterGroessen: string[] = [];
    _filterFarben: string[] = [];
    _filterMerkmale: number[] = [];

    filterGroesse: string[] = [];
    filterFarbe: string[] = [];
    filterMerkmal: number[] = [];

    // Settings
    public config: PerfectScrollbarConfigInterface = {};

    // Utils
    isLoading: boolean = true;
    isCategoryFilter: boolean = false;
    isPreisFilter: boolean = false;
    isGroesseFilter: boolean = false;
    isFarbeFilter: boolean = false;
    isGroessenAvailable: boolean = false;
    isFarbenAvailable: boolean = false;
    isMerkmaleAvailable: boolean = false;
    isMerkmalGruppenAvailable: boolean = false;
    isMerkmalFilter: boolean = false;

    constructor(
        private router: Router,
    ) { }

    ngOnInit(): void {
    }

    loadData() {
        this.options = {
            floor: this.minPreis,
            ceil: this.maxPreis,
            translate: (value: number): string => {
                return value + '€';
            }
        };

        this.isLoading = false;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.category != null && changes.category.currentValue != null && changes.category.currentValue != changes.category.previousValue) {
            this.category = changes.category.currentValue;

            this.isCategoryFilter = true;
        }

        if (changes.minPreis != null && changes.minPreis.currentValue != null && changes.minPreis.previousValue != changes.minPreis.currentValue) {
            this.minPreis = changes.minPreis.currentValue;
        }

        if (changes.maxPreis != null && changes.maxPreis.currentValue != null && changes.maxPreis.previousValue != changes.maxPreis.currentValue) {
            this.maxPreis = changes.maxPreis.currentValue;
        }

        if (changes.groessen != null && changes.groessen.currentValue != null && changes.groessen.previousValue != changes.groessen.currentValue) {
            this.groessen = changes.groessen.currentValue;

            if (this.groessen.length > 0) {
                this.isGroessenAvailable = true;
            } else {
                this.isGroessenAvailable = false;
            }
        }
        
        if (changes.farben != null && changes.farben.currentValue != null && changes.farben.previousValue != changes.farben.currentValue) {
            this.farben = changes.farben.currentValue;
            if (this.farben.length > 0) {
                this.isFarbenAvailable = true;
            } else {
                this.isFarbenAvailable = false;
            }
        }

        if (changes.filterGroessen != null && changes.filterGroessen.previousValue != changes.filterGroessen.currentValue) {
            this.filterGroessen = changes.filterGroessen.currentValue;
            
            if(this.filterGroessen)
                this._filterGroessen = JSON.parse(this.filterGroessen);
            else
                this._filterGroessen=[];
        }

        if (changes.filterFarben != null  && changes.filterFarben.previousValue != changes.filterFarben.currentValue) {
            this.filterFarben = changes.filterFarben.currentValue;
            if(this.filterFarben)
                this._filterFarben = JSON.parse(this.filterFarben);
            else
                this._filterFarben=[];
            
        }

        if (changes.filterMerkmale != null  && changes.filterMerkmale.previousValue != changes.filterMerkmale.currentValue) {
            this.filterMerkmale = changes.filterMerkmale.currentValue;

            if(this.filterMerkmale)
                this._filterMerkmale = JSON.parse(this.filterMerkmale);
            else
                this._filterMerkmale=[];
        }

        if (changes.merkmalGruppen != null && changes.merkmalGruppen.currentValue != null && changes.merkmalGruppen.previousValue != changes.merkmalGruppen.currentValue) {
            this.merkmalGruppen = changes.merkmalGruppen.currentValue;

            if (this.merkmalGruppen.length > 0) {
                this.isMerkmalGruppenAvailable = true;
            } else {
                this.isMerkmalGruppenAvailable = false;
            }
        }

        if (changes.removeFilter != null && changes.removeFilter.currentValue != null && changes.removeFilter.currentValue != changes.removeFilter.previousValue) {
            this.getMerkmal(true, changes.removeFilter.currentValue);
        }

        this.setGroesse();
        this.setFarbe();
        this.setMerkmal();

        this.loadData();
    }

    onValuePreisChanged(changeContext: ChangeContext) {

        this.minPreis = changeContext.value;
        this.maxPreis = changeContext.highValue;

        this.routerNav();

        this.isPreisFilter = true;
    }

    removePriceFilter() {
        this.minPreis = 0;
        this.maxPreis = 0;

        this.routerNav();

        this.isPreisFilter = false;
    }

    getGroesse(event, groesse) {
        if (event.checked) {
            // add it
            this._filterGroessen.push(groesse.groesse_Wert);
        } else {
            // remove it
            const index = this._filterGroessen.indexOf(groesse.groesse_Wert);
            if (index > -1) {
                this._filterGroessen.splice(index, 1);
            }
        }

        this.routerNav();
    }

    setGroesse() {
        if (this._filterGroessen && this._filterGroessen.length > 0) {
            let res: Artikel.IArtikelListSettingGroessenDto;
            this._filterGroessen.forEach(x => {
                if (this.groessen) {
                    let idx = this.groessen.findIndex(y => y.groesse_Wert == x);

                    if (idx > -1) {
                        res = this.groessen[idx];
                        res.selected = true;
                    }
                }
            });
        }
    }

    getFarbe(event, farbe) {
        if (event.checked) {
            // add it
            this._filterFarben.push(farbe.farbe_Wert);
        } else {
            // remove it
            const index = this._filterFarben.indexOf(farbe.farbe_Wert);
            if (index > -1) {
                this._filterFarben.splice(index, 1);
            }
        }

        this.routerNav();
    }

    setFarbe() {
        if (this._filterFarben && this._filterFarben.length > 0) {
            let res: Artikel.IArtikelListSettingFarbenDto;
            this._filterFarben.forEach(x => {
                if (this.farben) {
                    let idx = this.farben.findIndex(y => y.farbe_Wert == x);

                    if (idx > -1) {
                        res = this.farben[idx];
                        res.selected = true;
                    }
                }
            });
        }
    }

    getMerkmal(event, merkmal) {
        if (event.checked) {
            // add merkmal to list
            this._filterMerkmale.push(merkmal.id);
        } else {
            // remove merkmal from list
            const index = this._filterMerkmale.indexOf(merkmal.id);
            if (index > -1) {
                this._filterMerkmale.splice(index, 1);
            }
        }

        this.routerNav();
    }

    setMerkmal() {
        if (this._filterMerkmale && this._filterMerkmale.length > 0) {
            let res: Artikel.IMerkmalDto;

            this._filterMerkmale.forEach(x => {
                if (this.merkmalGruppen) {
                    this.merkmalGruppen.forEach(z => {
                        let idx = z.merkmale.findIndex(y => y.id == x);

                        if (idx > -1) {
                            res = z.merkmale[idx];
    
                            if (res) {
                                res.selected = true;
                                z.isActive = true;
                            }
                        }
                    });
                }
            });
        }
    }

    onIsNurAuflagerChanged(event) {
        this.nurAufLager = event.checked;

        this.routerNav();
    }

    private routerNav() {

        // console.log("cat => ", this.category);
        // console.log("minpreis => ", this.minPreis);
        // console.log("maxpreis => ", this.maxPreis);
        // console.log("filtergrösse => ", this._filterGroessen);
        // console.log("filterfarbe => ", this._filterFarben);
        // console.log("nurauflager => ", this.nurAufLager);
        console.log("routerNav.filterMerkmale => ", this._filterMerkmale);

        console.log('--> route to articles');
        this.router.navigate(['/articles'], {
            queryParams: {
                category: this.category,
                minPreis: this.minPreis,
                maxPreis: this.maxPreis,
                groessen: this._filterGroessen.length > 0 ? JSON.stringify(this._filterGroessen) : null,
                farben: this._filterFarben.length > 0 ? JSON.stringify(this._filterFarben) : null,
                merkmale: this._filterMerkmale.length> 0 ? JSON.stringify(this._filterMerkmale) : null,
                nurAufLager: this.nurAufLager,
            }
        });
    }
}
